import { BaseComponent } from './../components/base.component';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CloseAction, OpenAction, SpinnerState } from '../store/spinner';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { catchError, map, Observable, of, takeUntil, tap } from 'rxjs';
import { ErrorHandlerService } from '../api/error-handler.service';

@Injectable({
  	providedIn: 'root'
})
export class FileService extends BaseComponent {
	private document: Document = new Document()
	constructor(
		private spinnerState: Store<SpinnerState>,
		private sanitizer: DomSanitizer,
		private errServ: ErrorHandlerService,
	) {
		super()
		// pdfjs 設定
		// this.document = document
	}

	/**
	 * 將base64轉為 Unit8Array bytes data
	 * @param base64 base64字串格式檔案
	 * @returns Uint8Array bytes data
	 */
	public base64ToArraybuffer(base64: string): Uint8Array{
		let binary_string = window.atob(base64)
		let len = binary_string.length
		let bytes = new Uint8Array(len);
		for (let i = 0; i < len; i++) {
		bytes[i] = binary_string.charCodeAt(i)
		}
		return bytes
	}


	/**
	 * 將 Uint8Array bytes data 轉為 URL
	 * @param bytesData Uint8Array bytes data
	 * @param type 檔案類型（如：'IMG', 'EXCEL', 'PDF'）
	 * @returns 回傳URL字串
	 */
	public getFileLink(bytesData: Uint8Array, type: string): string{
		let link = ''
		let _buffer = bytesData.buffer
		switch (type) {
		case 'IMG':
		case 'EXCEL':
			let fileBlob = new Blob([_buffer])
			link = window.URL.createObjectURL(fileBlob)
			break;
		case 'PDF':
			// PDF 為了要能預覽必須指定格式
			let pdfBlob = new Blob([bytesData], {type: "application/pdf"})
			link = URL.createObjectURL(pdfBlob);
			break;
		}
		return link
	}


	/**
	 * 將圖片URL進行安全性確認，讓HTML可直接載入顯示
	 * @param link 檔案URL
	 * @returns SafeResourceUrl物件
	 */
	public linkToSelfUrl(link: string): SafeResourceUrl{
		let url = this.sanitizer.bypassSecurityTrustResourceUrl(link)
		return url
	}


	/**
	 * 下載檔案
	 * @param href 檔案URL
	 * @param fileName 檔案名稱
	 */
	public downloadLink(href: string, fileName: string){
		const link = document.createElement('a')
		link.setAttribute('href', href)
		link.download = fileName;
		link.style.visibility = 'hidden'
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link);
	}

}
